import { AppState } from '../../types/redux/store';

export const getUiState = (state: AppState) => state.ui;
